import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "sticky-top-20 cart-checkout__sidebar" };
const _hoisted_2 = { class: "row pb-3 d-none d-md-block" };
const _hoisted_3 = { class: "col-12 text-center text-uppercase" };
const _hoisted_4 = { class: "text-primary" };
const _hoisted_5 = { class: "row pb-2 mt-3 mt-md-0" };
const _hoisted_6 = { class: "col-4" };
const _hoisted_7 = { class: "col-8 text-end" };
const _hoisted_8 = {
    key: 0,
    class: "row pb-2"
};
const _hoisted_9 = { class: "col-4 d-flex" };
const _hoisted_10 = { class: "col-8 text-end" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
        /*#__PURE__*/ _createElementVNode("hr", { class: "mt-2" })
    ])
], -1);
const _hoisted_12 = {
    key: 0,
    class: "row"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("hr", { class: "mt-2" })
], -1);
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = { class: "col-8" };
const _hoisted_16 = { class: "col-4 text-end" };
const _hoisted_17 = {
    key: 0,
    class: "spinner"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce1" }, null, -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce2" }, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce3" }, null, -1);
const _hoisted_21 = [
    _hoisted_18,
    _hoisted_19,
    _hoisted_20
];
const _hoisted_22 = { key: 1 };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
        /*#__PURE__*/ _createElementVNode("hr", { class: "my-2" })
    ])
], -1);
const _hoisted_24 = {
    key: 1,
    class: "row"
};
const _hoisted_25 = {
    key: 1,
    class: "col-12 mb-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.schema?.options?.text_Summary), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.schema?.options?.text_SummaryHint), 1)
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.schema?.options?.text_Cart), 1),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("b", null, _toDisplayString(_ctx.cart.cartNumber), 1)
            ])
        ]),
        (_ctx.cart?.cartName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.$tc('client.Commerce.Carts.Name')) + " ", 1),
                    (_ctx.cart?.cartState !== 'A')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.cmdRenameCart && _ctx.cmdRenameCart(...args)), ["prevent"])),
                            class: "text-muted ms-1 btn-image-link position-relative",
                            style: { "height": "24px", "padding": "4px" }
                        }, [
                            _createVNode(_component_g_icon, {
                                width: "16",
                                height: "16",
                                src: "/assets/icons/pen.svg",
                                style: { "vertical-align": "unset", "display": "inline-block" }
                            })
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.cart.cartName), 1)
                ])
            ]))
            : _createCommentVNode("", true),
        _hoisted_11,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cart?.summary, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (item.seperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: "row pb-2",
                    style: _normalizeStyle(_ctx.getFontStyle(item))
                }, [
                    _createElementVNode("div", _hoisted_15, [
                        _createTextVNode(_toDisplayString(item.caption), 1),
                        (item.image)
                            ? (_openBlock(), _createBlock(_component_g_icon, {
                                key: 0,
                                width: "16",
                                height: "16",
                                src: item.image,
                                class: "ms-1"
                            }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        (_ctx.status.isLoading && item.name === 'TOTAL')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_21))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(item.amountText), 1))
                    ])
                ], 4)
            ], 64));
        }), 256)),
        _hoisted_23,
        (_ctx.schema?.commands?.next)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema?.commands?.next, (button) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (button.fieldtype === 'label')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(['col-12 mb-2', button.cssClass])
                            }, [
                                _createVNode(_component_g_dynamic_html, {
                                    template: button.text
                                }, null, 8, ["template"])
                            ], 2))
                            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createVNode(_component_g_button, {
                                    text: button.caption,
                                    "button-style": button.style,
                                    "is-loading": _ctx.status.isWorking,
                                    onClick: ($event) => (_ctx.$emit('command', { name: button.mode }))
                                }, null, 8, ["text", "button-style", "is-loading", "onClick"])
                            ]))
                    ], 64));
                }), 256))
            ]))
            : _createCommentVNode("", true)
    ]));
}
